import { Button, Popconfirm, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { CiEdit, CiSquarePlus } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { AiOutlineDelete } from "react-icons/ai";
import KassaEdit from "../../Kassa/KassaEdit";
import formatNumberWithSpaces from "../../../Components/NumberToWords/FormatNumber";
import KassaAdd from "../../Kassa/KassaAdd";
import CustomerActions from "../../../Components/Customers/CustomerActions";
import { TbEyeEdit } from "react-icons/tb";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import moment from "moment";

export default function Dk() {
  let navigate = useNavigate();
  const { data, loading, error, fetchData } = OneCustomer();
  const { id } = useParams();

  let [one, setOne] = useState(null);
  let [openEdit, setOpenEdit] = useState(null);
  let [openAdd, setOpenAdd] = useState(false);

  // /api/dk/{customer_id}
  let getOneDk = async (id) => {
    try {
      let { data } = await axiosInstance.get("/api/kassa/" + id);

      console.log(data);
      setOne(data.data);
      setOpenEdit(true);
    } catch (error) {
      console.log(error);
    } finally {
      console.log("true");
    }
  };

  const handleDeletion = async (ids) => {
    try {
      let { data } = await axiosInstance.delete("/api/kassa/" + ids);
      if (data.success) {
        fetchData(id);
        console.log(data);
      }
    } catch (error) {}
  };

  return (
    <div className="flex flex-row items-start gap-1">
      <KassaEdit
        isModalOpen={openEdit}
        setIsModalOpen={setOpenEdit}
        getData={() => {}}
        info={one ? one : {}}
      />
      <div className="flex-1 flex flex-col justiyf-center ">
        <Button
          className="flex-1 my-2"
          onClick={() => {
            setOpenAdd(true);
          }}
          variant="solid"
          icon={<CiSquarePlus className="font-[30px]" />}
        >
          D - qo'shish
        </Button>
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
          }}
          border="1"
          className="text-[14px]"
          cellpadding="10"
        >
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
              Jami
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              {formatNumberWithSpaces(
                data?.akt_sverka_dk?.d
                  ? data?.akt_sverka_dk?.d
                      ?.reduce((acc, cur) => {
                        return acc + cur?.sum;
                      }, 0)
                      ?.toFixed(2)
                  : 0
              )}{" "}
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
          </tr>
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
              Sana
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Summa
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Izox
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              ?
            </th>
          </tr>
          {data?.akt_sverka_dk?.d
            ? data?.akt_sverka_dk?.d
                .sort(
                  (a, b) =>
                    moment(a.date, "YYYY-MM-DD") - moment(b.date, "YYYY-MM-DD")
                )
                .map((el) => {
                  return (
                    <tr>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <Tooltip
                          sx={{ fontSize: "10px" }}
                          title={
                            <>
                              <p className="m-0 p-0 text-[14px] text-[red]">
                                {el?.created_at?.split("T")[0]}
                              </p>
                              <p className="m-0 p-0 text-[14px] text-[red]">
                                {el?.created_at?.split("T")[1]}
                              </p>
                            </>
                          }
                        >
                          <p className="m-0 p-0 text-[14px]">
                            {el?.date?.split("T")[0]}
                          </p>
                          {/* {spliceWithDots(el?.comment)}{" "} */}
                        </Tooltip>
                      </td>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <p className="m-0 p-0 text-[14px]">
                          {formatNumberWithSpaces(
                            el.sum ? el.sum?.toFixed(2) : 0
                          )}
                        </p>
                      </td>
                      <td className="text-[10px] text-left text-bold border border-gray-400 px-4 py-1">
                        <Tooltip sx={{ fontSize: "10px" }} title={el?.comment}>
                          <p
                            className="m-0 p-0 text-[14px] w-[50px]"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el?.comment}
                          </p>
                          {/* {spliceWithDots(el?.comment)}{" "} */}
                        </Tooltip>
                      </td>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <div className="flex flex-row gap-1">
                          <CustomerActions
                            actions={[
                              {
                                type: "group",
                                key: "info",
                                label: el?.kassa_id ? (
                                  <div
                                    className=" block w-[100%] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                  >
                                    <TbEyeEdit className="font-[18px]" />{" "}
                                    <span className="text-[18px]">
                                      {el?.created_at?.split("T")[0]} da
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className=" block w-[100%] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                  >
                                    <TbEyeEdit className="font-[18px]" />{" "}
                                    <span className="text-[18px]">
                                      YKX {el?.created_at?.split("T")[0]}
                                    </span>
                                  </div>
                                ),
                              },
                              {
                                type: "divider",
                              },
                              {
                                key: "1",
                                disabled: !el?.kassa_id,
                                label: (
                                  <div
                                    className=" block w-[100%] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                      if (el?.kassa_id) {
                                        getOneDk(el?.kassa_id);
                                      }
                                    }}
                                  >
                                    <CiEdit className="font-[30px]" />{" "}
                                    O'zgartirish
                                  </div>
                                ),
                              },
                              {
                                key: "2",
                                disabled: !el?.kassa_id,
                                label: el?.kassa_id ? (
                                  <Popconfirm
                                    title="O'chirish"
                                    description={
                                      `'${formatNumberWithSpaces(
                                        el.sum ? el.sum : 0
                                      )}' summani` +
                                      " O'chirishga ishonchingiz komilmi?"
                                    }
                                    onConfirm={() => {
                                      handleDeletion(el?.kassa_id);
                                    }}
                                    // onCancel={cancel}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <div
                                      className=" block w-[100%] text-[red] flex items-center justify-start gap-2 "
                                      rel="noopener noreferrer"
                                    >
                                      <AiOutlineDelete className="font-[30px]" />
                                      O'chirish
                                    </div>
                                  </Popconfirm>
                                ) : (
                                  <div
                                    className=" block w-[100%] text-[#bd5e59] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                  >
                                    <AiOutlineDelete className="font-[30px]" />
                                    O'chirish
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
            : null}
        </table>
      </div>
      <KassaAdd
        setIsModalOpen={setOpenAdd}
        isModalOpen={openAdd}
        getData={() => {
          navigate(0);
        }}
      />
      <div className="flex-1 flex flex-col justiyf-center">
        <Button
          className="flex-1 my-2"
          onClick={() => {
            setOpenAdd(true);
          }}
          variant="solid"
          icon={<CiSquarePlus className="font-[30px]" />}
        >
          K - qo'shish
        </Button>
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
          }}
          border="1"
          className="text-[14px]"
          cellpadding="10"
        >
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
              Jami
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              {formatNumberWithSpaces(
                data?.akt_sverka_dk?.k
                  ? data?.akt_sverka_dk?.k
                      ?.reduce((acc, cur) => {
                        return acc + cur?.sum;
                      }, 0)
                      ?.toFixed(2)
                  : 0
              )}{" "}
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
          </tr>
          <tr>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
              Sana
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Summa
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              Izox
            </th>
            <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
              ?
            </th>
          </tr>
          {data?.akt_sverka_dk?.k
            ? data?.akt_sverka_dk?.k
                .sort(
                  (a, b) =>
                    moment(a.date, "YYYY-MM-DD") - moment(b.date, "YYYY-MM-DD")
                )
                .map((el) => {
                  return (
                    <tr>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <Tooltip
                          sx={{ fontSize: "10px" }}
                          title={
                            <>
                              <p className="m-0 p-0 text-[14px] text-[red]">
                                {el.created_at?.split("T")[0]}
                              </p>
                              <p className="m-0 p-0 text-[14px] text-[red]">
                                {el.created_at?.split("T")[1]}
                              </p>
                            </>
                          }
                        >
                          <p className="m-0 p-0 text-[14px]">
                            {el.date?.split("T")[0]}
                          </p>
                          {/* {spliceWithDots(el?.comment)}{" "} */}
                        </Tooltip>
                      </td>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <p className="m-0 p-0 text-[14px]">
                          {formatNumberWithSpaces(
                            el.sum ? el.sum?.toFixed(2) : 0
                          )}
                        </p>
                      </td>
                      <td
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        className="text-[10px] text-left text-bold border border-gray-400 px-4 py-1"
                      >
                        <Tooltip
                          sx={{ fontSize: "10px" }}
                          className="text-[14px]"
                          title={el?.comment}
                        >
                          <p
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el?.comment?.length > 5
                              ? el?.comment?.slice(0, 6) + "..."
                              : el?.comment}
                          </p>
                        </Tooltip>
                      </td>
                      <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                        <div className="flex flex-row gap-1">
                          {" "}
                          <CustomerActions
                            actions={[
                              {
                                type: "group",
                                key: "info",
                                label: (
                                  <div
                                    className=" block w-[100%] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                  >
                                    <TbEyeEdit className="font-[18px]" />{" "}
                                    <span className="text-[18px]">
                                      21.02.2025 da
                                    </span>
                                  </div>
                                ),
                              },
                              {
                                type: "divider",
                              },
                              {
                                key: "1",
                                label: (
                                  <div
                                    className=" block w-[100%] flex items-center justify-start gap-2 "
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                      if (el?.kassa_id) {
                                        getOneDk(el?.kassa_id);
                                      }
                                    }}
                                  >
                                    <CiEdit className="font-[30px]" />{" "}
                                    O'zgartirish
                                  </div>
                                ),
                              },
                              {
                                key: "2",
                                label: el?.kassa_id ? (
                                  <Popconfirm
                                    title="O'chirish"
                                    description={
                                      `'${formatNumberWithSpaces(
                                        el.sum ? el.sum : 0
                                      )}' summani` +
                                      " O'chirishga ishonchingiz komilmi?"
                                    }
                                    onConfirm={() => {
                                      handleDeletion(el?.kassa_id);
                                    }}
                                    // onCancel={cancel}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <div
                                      className=" block w-[100%] text-[red] flex items-center justify-start gap-2 "
                                      rel="noopener noreferrer"
                                    >
                                      <AiOutlineDelete className="font-[30px]" />
                                      O'chirish
                                    </div>
                                  </Popconfirm>
                                ) : null,
                              },
                            ]}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
            : null}
        </table>
      </div>
    </div>
  );
}
